import { PageId } from 'constants/pages'

export const enum PageIdWoofzPupWt {
  DOG_AGE_PUP_WT = PageId.DOG_AGE_PUP_WT,
  DOG_OWNER_PUP_WT = PageId.DOG_OWNER_PUP_WT,
  TRAINING_COMMANDS_PUP_WT = PageId.TRAINING_COMMANDS_PUP_WT,
  URGE_PAGE_PUP_WT = PageId.URGE_PAGE_PUP_WT,
  DOG_BREED_PUP_WT = PageId.DOG_BREED_PUP_WT,
  FACING_CHALLENGES_PUP_WT = PageId.FACING_CHALLENGES_PUP_WT,
  FACING_CHALLENGES_2_PUP_WT = PageId.FACING_CHALLENGES_2_PUP_WT,
  BEHAVIOR_FREQUENCY_PUP_WT = PageId.BEHAVIOR_FREQUENCY_PUP_WT,
  URGE_PROGRAM_PUP_WT = PageId.URGE_PROGRAM_PUP_WT,
  BEHAVIOR_FEELINGS_PUP_WT = PageId.BEHAVIOR_FEELINGS_PUP_WT,
  FIX_BEHAVIOR_PUP_WT = PageId.FIX_BEHAVIOR_PUP_WT,
  URGE_PAGE_4_PUP_WT = PageId.URGE_PAGE_4_PUP_WT,
  COMMANDS_PUP_WT = PageId.COMMANDS_PUP_WT,
  PARENT_GOAL_PUP_WT = PageId.PARENT_GOAL_PUP_WT,
  TRAINING_PLACE_PUP_WT = PageId.TRAINING_PLACE_PUP_WT,
  TRAINING_FREQUENCY_PUP_WT = PageId.TRAINING_FREQUENCY_PUP_WT,
  URGE_PAGE_5_PUP_WT = PageId.URGE_PAGE_5_PUP_WT,
  PREPARE_FLOW_PUP_WT = PageId.PREPARE_FLOW_PUP_WT,
  EMAIL_PUP_WT = PageId.EMAIL_PUP_WT,
  NEWSLETTER_URGE_PUP_WT = PageId.NEWSLETTER_URGE_PUP_WT,
  LAST_CHANCE_OFFER_PUP_WT = PageId.LAST_CHANCE_OFFER_PUP_WT,
  SUBSCRIPTIONS_PUP_WT = PageId.SUBSCRIPTIONS_PUP_WT,
  CHAT_UPSELL_PUP_WT = PageId.CHAT_UPSELL_PUP_WT,
  UPSELL_PUP_WT = PageId.UPSELL_PUP_WT,
  UPSELL_FEEDING_GUIDE_PUP_WT = PageId.UPSELL_FEEDING_GUIDE_PUP_WT,
  UPSELL_EMOTIONAL_SUPPORT_PUP_WT = PageId.UPSELL_EMOTIONAL_SUPPORT_PUP_WT,
  DOWNLOAD_PUP_WT = PageId.DOWNLOAD_PUP_WT,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
